import type { IOffer } from "@bbj-types/offer";
import type { IOffersFiltersBody } from "@bbj-types/offer/dashboard";
import type { OfferKind } from "@root/utils/enums/offer";
import { useCallback } from "react";
import { axios } from "./axios";
import type { ISocialOfferWithFavoriteChallenges } from "./socialOffer/types";

interface IUsePostJobOffersDashboardBody {
  data: IOffer[];
  totalLimit: number;
  offersLimit: number;
  limit: number;
  skip: number;
  total: number;
  count: number;
  orderStrategy: unknown;
  metadata: unknown;
}

export interface IUsePostSocialOffersDashboardBody {
  data: ISocialOfferWithFavoriteChallenges[];
  totalLimit: number;
  offersLimit: number;
  skip: number;
  total: number;
  count: number;
  orderStrategy: unknown;
  metadata: unknown;
}

export const usePostOffersDashboard = <Kind extends OfferKind>(kind: Kind) => {
  const [state, execute, cancel] = axios<
    Kind extends OfferKind.JOB ? IUsePostJobOffersDashboardBody : IUsePostSocialOffersDashboardBody
  >(
    {
      method: "post",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (filters: IOffersFiltersBody) => {
      return execute({
        url: `/offers/dashboard/${kind}`,
        data: filters,
      });
    },
    [execute, kind]
  );

  return [state, callback, cancel] as const;
};
